import { Box, Image } from "@chakra-ui/react";
import React from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import useWebsiteInfo from "../../../hook/useWebsiteInfo";

const ReloadButton = () => {
  // 取網站資訊 - 直接獲取預處理好的圖片路徑
  const { images } = useWebsiteInfo();

  return (
    <Box
      onClick={() => {
        window.location.reload(); // 重新載入頁面
      }}
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
      shadow="sm"
    >
      <Image
        src={images.refresh}
        height={{
          base: "40px",
          sm: "50px",
          md: "60px",
        }}
        minW={{
          base: "40px",
          sm: "50px",
          md: "60px",
        }}
      />
    </Box>
  );
};

export default ReloadButton;
